<template>
  <div>
    <Modal v-model="show" width="360">
      <p slot="header" style="color: #2d8cf0; text-align: left">
        <Icon type="ios-information-circle"></Icon>
        <span> 部署集群</span>
      </p>
      <div style="text-align:center">
        <Input v-model="cluster" placeholder="要部署的集群名称（选填）" maxlength="128" show-word-limit/>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long :loading="loading" @click="startDeploy">开始部署</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { deployContainerStack } from '@/api/container/stack'

export default {
  name: 'deploy-confirm',
  data () {
    return {
      stackId: null,
      show: false,
      cluster: '',
      loading: false
    }
  },
  methods: {
    // 执行部署
    deploy (id) {
      this.stackId = id
      this.show = true
    },
    startDeploy () {
      this.loading = true
      deployContainerStack({cluster: this.cluster}, this.stackId).then(res => {
        this.$emit('callback', this.stackId, res.data.task_id)
        this.$Notice.success({ title: '操作成功，堆栈开始部署！' })
        this.show = false
        this.loading = false
      }).catch(res => {
        this.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败!',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
